const STOREFRONT_API_CONFIG = {
  endpoint: 'https://textile-amc9wusze-aarifs-projects-a778116f.vercel.app/api/webhook',
  timeout: 30000
};

function submitOrderViaWebhook(orderData) {
  const clientSecret = (window && window.CUSTOM_CHECKOUT_SHARED_SECRET) 
    ? window.CUSTOM_CHECKOUT_SHARED_SECRET 
    : '4f9b2e3a9c1d6f7e8b4a2c3d9e7f6b1c';

  const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  if (clientSecret && clientSecret !== '4f9b2e3a9c1d6f7e8b4a2c3d9e7f6b1c') {
    headers['X-Client-Secret'] = clientSecret;
  } else {
    console.warn('No valid client secret found');
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), STOREFRONT_API_CONFIG.timeout);

  return (async () => {
    try {
      const resp = await fetch(STOREFRONT_API_CONFIG.endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({ order: orderData, source: 'custom_checkout_overlay', timestamp: new Date().toISOString() }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      const is2xx = resp.status >= 200 && resp.status < 300;

      let json = null;
      try {
        const text = await resp.text();
        if (text && text.length > 0) {
          json = JSON.parse(text);
        }
      } catch (parseErr) {
        console.warn('Webhook response is not JSON:', parseErr);
      }

      if (!is2xx) {
        // If server returned an error status, surface helpful message
        const serverMsg = (json && (json.error || json.message)) || `Webhook failed with status ${resp.status}`;
        const err = new Error(serverMsg);
        err.status = resp.status;
        err.response = json;
        throw err;
      }

      // Return a consistent success object so theme can rely on it
      return {
        ok: true,
        status: resp.status,
        body: json
      };
    } catch (err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        throw new Error('Request timeout - please try again');
      }
      throw err;
    }
  })();
}

/**
 * Validate order data before submission
 * @param {Object} orderData - The order data to validate
 * @returns {Object} - Validation result with isValid boolean and errors array
 */
function validateOrderData(orderData) {
  const errors = [];
  
  if (!orderData.email || !orderData.email.includes('@')) {
    errors.push('Valid email address is required');
  }
  
  if (!orderData.order_items || !Array.isArray(orderData.order_items) || orderData.order_items.length === 0) {
    errors.push('At least one order item is required');
  }
  
  if (!orderData.name || orderData.name.trim().length === 0) {
    errors.push('Customer name is required');
  }
  
  // Validate order items
  if (orderData.order_items && Array.isArray(orderData.order_items)) {
    orderData.order_items.forEach((item, index) => {
      if (!item.title && !item.name) {
        errors.push(`Order item ${index + 1} is missing title/name`);
      }
      if (!item.quantity || item.quantity <= 0) {
        errors.push(`Order item ${index + 1} must have valid quantity`);
      }
      if (!item.price || isNaN(parseFloat(item.price))) {
        errors.push(`Order item ${index + 1} must have valid price`);
      }
    });
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors
  };
}

// Export functions for use in other scripts
window.StorefrontAPI = {
  submitOrderViaWebhook: submitOrderViaWebhook,
  validateOrderData: validateOrderData
};
